<template>
  <div v-if="videoPlaylistIsLoaded" ref="wrapper">
    <iframe v-if="videoPlaylistUrl" class="rounded-lg" width="100%" :height="height" :src="videoPlaylistUrl"
      style="border: none;" allowfullscreen @load="loaded" />
  </div>
</template>

<script>
import { EmbeddedPlayerMessageHandler } from "@/components/VideoPlayers/VideoPlaylist/EmbeddedPlayerMessageHandler";
import { mapGetters, mapState } from "vuex";
import getUrlParameter from "../../../utils/getUrlParameter";

export default {
  name: 'ShowcasePlayer',
  props: {
    userId: Number | String,
    root: {
      type: String | HTMLElement,
      default: null,
    },
    rootMargin: {
      type: String,
      default: '-58px',
    },
    ratioHeightOffset: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    messageHandler: null,
    height: 0,
  }),
  computed: {
    ...mapGetters('videoLibrary', ['getVideoPlaylistIsLoaded', 'getVideoPlaylistUrl', 'getVideoPlaylistId']),
    ...mapState('athleteProfile', ['isModal']),
    videoPlaylistIsLoaded() {
      return !!this.getVideoPlaylistIsLoaded;
    },
    videoPlaylistUrl() {
      console.log('videoPlaylistUrl', this.getVideoPlaylistUrl, this.videoPlaylistUrlParams)
      return `${this.getVideoPlaylistUrl}${this.videoPlaylistUrlParams}`;
    },
    videoPlaylistUrlParams() {
      const profileKey = getUrlParameter('k') ? `&k=${getUrlParameter('k')}` : '';
      const referrer = `&referrer=${encodeURIComponent(document.referrer || 'null')}`;
      const location = `&location=${encodeURIComponent(window.location.href)}`;
      const source = `&source=${this.isModal ? 'discover' : 'null'}`;
      return `?ratioHeightOffset=${this.ratioHeightOffset}${profileKey}${referrer}${location}${source}`
    },
    videoPlaylistId() {
      return this.getVideoPlaylistId;
    },
  },
  watch: {
    videoPlaylistUrl() {
      this.initMessageHandler();
    },
  },
  async beforeMount() {
    if (!this.videoPlaylistIsLoaded) {
      await this.$store.dispatch("videoLibrary/fetchVideoPlaylist", this.userId);
    } else {
      this.initMessageHandler();
    }
  },
  beforeDestroy() {
    this.messageHandler.disconnect();
  },
  methods: {
    initMessageHandler() {
      if (!!this.videoPlaylistUrl) {
        this.$nextTick(() => {
          this.messageHandler = EmbeddedPlayerMessageHandler.instance(
            this.videoPlaylistId,
            this.root,
            this.rootMargin,
            this.$refs.wrapper.querySelector('iframe'),
          );

          this.messageHandler.init();

          window.addEventListener('showcase-resized', e => {
            this.height = e.detail.height;
            this.$emit('resized', e.detail.height);
          });
        });
      }
    },
    loaded() {
      this.$emit('loaded');
    },
  },
};
</script>